var map = {
	"./arrow.svg": "b94f",
	"./check.svg": "f222",
	"./gallery.png": "37bd",
	"./gallery.svg": "19ff",
	"./images/avocado.jpg": "8806",
	"./images/disco.jpg": "12bb",
	"./images/disco_2.jpg": "5ee4",
	"./images/disco_3.jpg": "2886",
	"./images/lemon.jpg": "3de7",
	"./images/orange.jpg": "6de0",
	"./logo1-full.svg": "6ca0",
	"./logo2-negative.svg": "9541",
	"./logo3-flat.svg": "6d67",
	"./logo4-violet.svg": "cbba",
	"./logo5-magenta.svg": "2872",
	"./logo6-black.svg": "28e2",
	"./megaphone-1.svg": "8741",
	"./megaphone.png": "208f",
	"./megaphone.svg": "36b7",
	"./music-note.png": "9b39",
	"./music-note.svg": "3416",
	"./navarrow.svg": "4333",
	"./party.jpg": "3757",
	"./user-icon.svg": "9780",
	"./whatsapp.png": "9673"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";